import { logger } from 'utils/logger';
import { hasDisplayMediaSupport } from 'features/user-media/utils';

export const getDisplayMedia = async () => {
  if (!hasDisplayMediaSupport()) {
    logger.remote({ tier: 1 }).warn('Display capture is unavailable in this browser');

    throw new DOMException(
      'navigator.mediaDevices.getDisplayMedia is unavailable',
      'NotSupportedError'
    );
  }

  const constraints = {
    audio: {
      autoGainControl: true,
      echoCancellation: true,
      noiseSuppression: true,
    },
    video: {
      width: { max: 1920 },
      height: { max: 1080 },
    },
  };

  logger.remote({ tier: 1 }).info('Requesting display media', constraints);

  const stream = await navigator.mediaDevices.getDisplayMedia(constraints);

  const tracks = stream.getTracks();

  tracks.forEach((track) => {
    logger.remote({ tier: 1 }).info(`${track.kind} track settings:`, track.getSettings());
    logger.remote({ tier: 1 }).info(`${track.kind} track constraints:`, track.getConstraints());
  });

  return stream;
};
